import { useEffect } from "react";

/**
 * This runs an action when you visit the hash (e.g. #oversikt-hendelser) then clears the hash.
 * Example use case is redirecting the user to some specific modal/Tabs from any location.
 *
 * @param hash string that starts with '#'
 * @param action what to run when location is changed to 'hash'
 */
export const useLocationHash = (hash: string, action: () => void) => {
  useEffect(() => {
    const checkHash = () => {
      if (window.location.hash === hash) {
        action();

        // Remove the hash from URL without triggering a page reload
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search,
        );
      }
    };

    // Check on mount
    checkHash();

    // Listen for hash changes
    window.addEventListener("hashchange", checkHash);

    return () => {
      window.removeEventListener("hashchange", checkHash);
    };
  }, []);
};
